import { useState } from 'react';
import useReactRouter from 'use-react-router';
import { createContainer } from 'unstated-next';

import { StockOrder, StockLensData, StockOrderRequest, StockOrderStatusEnum, StockOrdersApi, Configuration } from 'openapi';

export default createContainer(() => {

  const [stockOrders, setStockOrders] = useState<StockOrder[]>([]);
  const { history } = useReactRouter();

  const load = async (recordedDate: Date) => {
    try {
      const response = await new StockOrdersApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).getStockOrders({ recordedDate });

      setStockOrders(response);
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  };

  const create = async (stockLensData: StockLensData) => {
    try {
      stockLensData.sph = Number(stockLensData.sph);
      stockLensData.cyl = Number(stockLensData.cyl);

      const response = await new StockOrdersApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).createStockOrder({ stockLensData });

      setStockOrders([...stockOrders, { ...response, ...stockLensData, status: StockOrderStatusEnum.Waiting }]);
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  };

  const update = async (newStockOrder: StockOrder) => {
    try {
      newStockOrder.sph = Number(newStockOrder.sph);
      newStockOrder.cyl = Number(newStockOrder.cyl);

      await new StockOrdersApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).updateStockOrder({ meganetLensOrderId: newStockOrder.meganetLensOrderId, stockLensData: newStockOrder as StockLensData });

      setStockOrders(stockOrders => {
        var index = stockOrders.findIndex(stockOrder => stockOrder.meganetLensOrderId === newStockOrder.meganetLensOrderId);
        return [...stockOrders.slice(0, index), newStockOrder, ...stockOrders.slice(index + 1)];
      });
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  };

  const remove = async (meganetLensOrderId: number) => {
    try {
      await new StockOrdersApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).deleteStockOrder({ meganetLensOrderId });

      setStockOrders(stockOrders => {
        var index = stockOrders.findIndex(stockOrder => stockOrder.meganetLensOrderId === meganetLensOrderId);
        return [...stockOrders.slice(0, index), ...stockOrders.slice(index + 1)];
      });
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  };

  const order = async (stockOrderRequest: StockOrderRequest) => {
    try {
      await new StockOrdersApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).requestStockOrders({ stockOrderRequest });

      var requestIds = stockOrderRequest.requests.map(request => request.meganetLensOrderId);

      setStockOrders(stockOrders => {

        var newStockOrders = stockOrders.slice();

        newStockOrders.forEach(stockOrder => {
          if (requestIds.includes(stockOrder.meganetLensOrderId)) {
            stockOrder.status = StockOrderStatusEnum.Requesting;
          }
        })

        return newStockOrders;
      });
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  };

  const getStatusList = async (meganetLensOrderId?: number, status?: number) => {
    try {
      var results = await new StockOrdersApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).getStockOrderStatusList({ meganetLensOrderId, status });
      return results.map(res => {
        return { ...res, orderType: 0 }
      });
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  }

  return { stockOrders, setStockOrders, load, create, update, remove, order, getStatusList };
});
